export namespace RiderFareErrorConstants {
  export const TICKET_NUMBER_MUST_BE_UNIQUE: RegExp = /ticketNumber=\[.*\] must be unique/;
  export const TICKET_NUMBER_EXCEEDS_MAX_USAGE: RegExp = /ticketNumber=\[(.*)\] has been used the maximum amount of times/;
  export const FAILED_TO_DETECT_TEXT_FOR_IMAGE: RegExp = /Failed to detect text for image/;
}
